const EMIT = 'emit'
const SELF_HANDLE = 'self_handle'
const ROUTE_JUMP = 'routeJump'

const CLICK_EVENT_TYPE = {
  EMIT,
  SELF_HANDLE,
  ROUTE_JUMP
}

const NUM = 'num'
const CLEAR = 'clear'
const DELETE = 'delete'
const KEYBOARDS_TYPE = {
  NUM,
  CLEAR,
  DELETE
}

const DEFAULT_THEME = 'default_theme'
const TRANSPARENT_THEME = 'transparent'
const LINEAR_GRADIENT_THEME = 'linear_gradient_theme'

const THEME_TYPE = {
  DEFAULT_THEME,
  TRANSPARENT_THEME,
  LINEAR_GRADIENT_THEME
}



const OCR_ANNEX = 'ocr_annex' //ocr附件
const NOT_SELECTED = 'not_selected' //未选择附件
const ORIGINAL_ATTACHMENT_PREVIEW = 'original_attachment_preview' //原附件预览
const AFTER_VERIFICATION_PREVIEW = 'after_verification_Preview' //校验后的预览
const OCR_CAMERA = 'ocr_camera' //OCR拍摄校验页面
const OCR_SCANNER = 'ocr_scanner' // OCR扫描仪
const OCR_MANUAL_APPROVAL = 'ocr_manual_approval' // 人工审批
const OCR_PARSING_FAILED = 'ocr_parsing_failed' // OCR文件解析失败

const OCR_PAGE_TYPE = {
  OCR_ANNEX, 
  OCR_PARSING_FAILED,
  NOT_SELECTED,
  ORIGINAL_ATTACHMENT_PREVIEW,
  AFTER_VERIFICATION_PREVIEW,
  OCR_SCANNER,
  OCR_CAMERA,
  OCR_MANUAL_APPROVAL
}



//整份、单份
const SINGLE_WHOLE_CHECK_PAGE = 'single_whole_check_page'
//单页
const SINGLE_PAGE_CHECK_PAGE = 'single_page_check_page'
//OCR使用的校验页面
const OCR_CHECK_PAGE_TYPE = {
  SINGLE_PAGE_CHECK_PAGE,
  SINGLE_WHOLE_CHECK_PAGE
}

const SINGLE_PAGE  = 'single_page' //单页
const SINGLE_COPY = 'single_copy' //单份
const WHOLE_COPY = 'whole_copy' //整份
const WHOLE_COPY_AND_SCAN = 'whole_copy_and_scan' //整份扫描仪

const OCR_TYPE = {
  SINGLE_PAGE,
  SINGLE_COPY,
  WHOLE_COPY,
  WHOLE_COPY_AND_SCAN
}

const SCANNER_VERIFICATION_METHOD = 'scanner_verification_method' //扫描仪
const TAKE_PICTURE_VERIFICATION_METHOD = 'take_picture_verification_method' //拍照片
const VERIFICATION_METHOD_TYPE = {
  SCANNER_VERIFICATION_METHOD,  
  TAKE_PICTURE_VERIFICATION_METHOD, //拍照片
}

//拍摄图片页面展示
const VIEW_LIST = 'view_list' //列表
const VIEW_IMG = 'view_img' //预览
const CORRECT_IMG_VIEW_TYPE = {
  VIEW_LIST,
  VIEW_IMG
}


//图片库类型
const CORRECT_IMG_LIBRARY = 'correct_img_library'
const USE_DEVICE_IMG_LIBRARY = 'use_device_img_library'
const IMG_LIBRARY_TYPE = {
  CORRECT_IMG_LIBRARY, //矫正图片库
  USE_DEVICE_IMG_LIBRARY //用印图片库
}


export default {
  CLICK_EVENT_TYPE,
  KEYBOARDS_TYPE,
  THEME_TYPE,
  OCR_PAGE_TYPE,
  OCR_CHECK_PAGE_TYPE,
  OCR_TYPE,
  CORRECT_IMG_VIEW_TYPE,
  IMG_LIBRARY_TYPE,
  VERIFICATION_METHOD_TYPE
}
